export const SET_LAY = "SET_LAY";
export const CLEAR_LAY = "CLEAR_LAY";

const initialState = {
  lay: null,
  layTab: null,
  layList: null,
  orderFlow: null
};

const layReducer = (state = initialState, action) => {
  if (action.type === SET_LAY) {
    return action.payload;
  } else if (action.type === CLEAR_LAY) {
    return null;
  }
  return state;
};

export default layReducer;
